import { render, staticRenderFns } from "./redpacketManage.vue?vue&type=template&id=65510ece&scoped=true&"
import script from "./redpacketManage.vue?vue&type=script&lang=js&"
export * from "./redpacketManage.vue?vue&type=script&lang=js&"
import style0 from "./redpacketManage.vue?vue&type=style&index=0&id=65510ece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65510ece",
  null
  
)

export default component.exports